export const wattageCalculator = function (data) {
    const _config = {
        multipliers: {
            roomTypes: {
                bedroom: 70,
                bathroom: 85,
                livingroom: 85,
                studyroom: 85,
                kitchen: 77
            },
            isolation: [
                1.15, // key 0 -> not isolated
                0.9 // key 1 -> isolated
            ]
        },

        data: {
            roomType: data.roomType ?? null,
            roomLength: Number(data.roomLength) || 0,
            roomWidth: Number(data.roomWidth) || 0,
            roomHeight: Number(data.roomHeight) || 0,
            isIsolated: data.isIsolated === 'yes' ? 1 : data.isIsolated === 'no' ? 0 : null
        }
    };

    const missingInput =
        !_config.data.roomType ||
        !_config.data.roomLength ||
        !_config.data.roomWidth ||
        !_config.data.roomHeight ||
        _config.data.isIsolated === null;

    if (missingInput) {
        document.getElementById('validation-notice').style.display = 'block';
        return false;
    }

    const volume = (_config.data.roomLength / 100) * (_config.data.roomWidth / 100) * (_config.data.roomHeight / 100);

    const roomTypeMultiplier = _config.multipliers.roomTypes[_config.data.roomType];
    const isolationMultiplier = _config.multipliers.isolation[_config.data.isIsolated];
    const wattage = volume * roomTypeMultiplier * isolationMultiplier;

    return wattage.toFixed(2);
};

export const updateWattage = function () {
    const roomTypeRadios = document.getElementsByName('room-type');
    const isIsolatedRadios = document.getElementsByName('is-isolated');
    let selectedRoomType = null;
    let isIsolated = null;

    for (let i = 0; i < roomTypeRadios.length; i++) {
        if (roomTypeRadios[i].checked) {
            selectedRoomType = roomTypeRadios[i].value;
            break;
        }
    }

    for (let i = 0; i < isIsolatedRadios.length; i++) {
        if (isIsolatedRadios[i].checked) {
            isIsolated = isIsolatedRadios[i].value;
            break;
        }
    }

    const data = {
        roomType: selectedRoomType,
        roomLength: document.getElementById('room-length').value,
        roomWidth: document.getElementById('room-width').value,
        roomHeight: document.getElementById('room-height').value,
        isIsolated: isIsolated
    };
    const wattage = wattageCalculator(data);

    if (wattage) {
        document.getElementById('wattage-calculated').style.display = 'block';
        document.getElementById('wattage-result').textContent = wattage + ' W';
        document.getElementById('validation-notice').style.display = 'none';
    } else {
        document.getElementById('wattage-calculated').style.display = 'none';
        document.getElementById('validation-notice').style.display = 'block';
    }
};

updateWattage();
window.updateWattage = updateWattage;
